import React from "react";
import auth, { getProxyPercentWidth } from "../../js/auth";

class CategoryButton extends React.Component {
    constructor(props) {
        super(props);

        const images = props.category.activeMenuItems
            .filter(m => m.image).map(m => ({ id: m.image, timestamp: m.imageTimestamp }));

        this.state = {
            images,
            currentImageIndex: 0,
            transitionImageIndex: null,
            isLoading: false,
            isTransitioning: false
        };
        this.isSwitching = false;
        this.imageUrlCache = {};
        this.imageLoadCache = {};
        this.imageElementCache = {};
    }

    componentDidMount() {
        const { images } = this.state;
        if (images.length > 1) {
            this.preloadAllImages();
        }
    }

    componentDidUpdate(prevProps) {
        const images = this.props.category.activeMenuItems
            .filter(m => m.image).map(m => ({ id: m.image, timestamp: m.imageTimestamp }));
        if (JSON.stringify(this.state.images) != JSON.stringify(images))
            this.setState({ images });

        const didTransitionVersionChange = this.props.transitionVersion !== prevProps.transitionVersion;
        if (this.props.canTransition && (didTransitionVersionChange || (!prevProps.canTransition && this.props.canTransition)) && this.state.images.length > 1) {
            this.nextImage();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.transitionTimer);
    }

    getImageUrl = (image) => {
        const src = `${auth.server}/${auth.war}/tableService/${localStorage.restaurantSelected}/getImage/${image.id}?timestamp=${image.timestamp}&instance=${localStorage.instance}`;
        if (!this.imageUrlCache[src]) {
            this.imageUrlCache[src] = getProxyPercentWidth(30, src);
        }
        return this.imageUrlCache[src];
    };

    preloadImage = (src) => {
        if (this.imageLoadCache[src] === true) {
            return Promise.resolve(true);
        }

        if (this.imageLoadCache[src] === false) {
            return Promise.resolve(false);
        }

        let img = this.imageElementCache[src];
        if (!img) {
            img = new Image();
            this.imageElementCache[src] = img;
        }

        if (img.complete && img.naturalWidth > 0) {
            this.imageLoadCache[src] = true;
            return Promise.resolve(true);
        }

        return new Promise((resolve) => {
            const handleLoad = () => {
                this.imageLoadCache[src] = true;
                resolve(true);
            };
            const handleError = () => {
                this.imageLoadCache[src] = false;
                resolve(false);
            };

            img.onload = handleLoad;
            img.onerror = handleError;
            if (!img.src || img.src !== src) {
                img.src = src;
            }
        });
    };

    preloadAllImages = async () => {
        const { images } = this.state;
        await Promise.all(images.map((image) => this.preloadImage(this.getImageUrl(image))));
    };

    nextImage = async () => {
        const { images, currentImageIndex, isTransitioning } = this.state;
        if (images.length < 2 || this.isSwitching || isTransitioning) return;

        const nextIndex = (currentImageIndex + 1) % images.length;
        const nextImageSrc = this.getImageUrl(images[nextIndex]);

        this.isSwitching = true;
        this.setState({ isLoading: true });

        const loaded = await this.preloadImage(nextImageSrc);
        if (!loaded) {
            this.isSwitching = false;
            this.setState({ isLoading: false });
            return;
        }

        this.setState({
            transitionImageIndex: nextIndex,
            isLoading: false,
            isTransitioning: true
        });

        setTimeout(() => {
            this.setState({
                currentImageIndex: nextIndex,
                transitionImageIndex: null,
                isTransitioning: false
            });
            this.isSwitching = false;
        }, 350);
    }

    render() {
        const { images, currentImageIndex, transitionImageIndex, isTransitioning } = this.state;
        const { category, onClick, selected, myRef, index } = this.props;

        if (images.length === 0) return null;

        const currentImage = this.state.images[(currentImageIndex + images.length) % images.length];
        const currentImageSrc = this.getImageUrl(currentImage);
        const transitionImage = transitionImageIndex !== null ? this.state.images[(transitionImageIndex + images.length) % images.length] : null;
        const transitionImageSrc = transitionImage ? this.getImageUrl(transitionImage) : currentImageSrc;

        return (
            <div index={index} name={category.name} ref={myRef} key={category.id} className={"kioskMenuCategory " + (selected ? "selected" : "")} >
                <div key={category.id}
                    className="kioskMenuCategoryButton"
                >
                    <div className="kioskMenuCategoryImageWrapperWrapper" onClick={onClick}>
                        <div className="kioskMenuCategoryImageWrapper"
                            style={{
                                opacity: transitionImageIndex === null ? 1 : 1,
                                zIndex: 2,
                                transform: isTransitioning ? 'scale(1.06)' : 'scale(1)',
                                transition: 'opacity 650ms cubic-bezier(0.22, 1, 0.36, 1), transform 650ms cubic-bezier(0.22, 1, 0.36, 1)',
                            }}
                        >
                            <div className="kioskMenuCategoryImage"
                                key={0}
                                alt=""
                                style={{
                                    backgroundImage: `url(${currentImageSrc})`,
                                    opacity: transitionImageIndex === null ? 1 : 1,
                                    transform: isTransitioning ? 'scale(1.08)' : 'scale(1)',
                                    transition: 'opacity 650ms cubic-bezier(0.22, 1, 0.36, 1), transform 650ms cubic-bezier(0.22, 1, 0.36, 1)',
                                }}
                            />
                        </div>
                        {transitionImageIndex !== null && (
                            <div className="kioskMenuCategoryImageWrapper"
                                style={{
                                    opacity: isTransitioning ? 1 : 0,
                                    zIndex: 3,
                                    transform: isTransitioning ? 'scale(1)' : 'scale(1.08)',
                                    transition: 'opacity 650ms cubic-bezier(0.22, 1, 0.36, 1), transform 650ms cubic-bezier(0.22, 1, 0.36, 1)',
                                }}
                            >
                                <div className="kioskMenuCategoryImage"
                                    key={1}
                                    alt={category.name}
                                    style={{
                                        backgroundImage: `url(${transitionImageSrc})`,
                                        opacity: isTransitioning ? 1 : 0,
                                        transform: isTransitioning ? 'scale(1)' : 'scale(1.12)',
                                        transition: 'opacity 650ms cubic-bezier(0.22, 1, 0.36, 1), transform 650ms cubic-bezier(0.22, 1, 0.36, 1)',
                                    }}
                                >
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="kioskMenuCategoryTitle">{category.name}</div>
                </div>
            </div >
        );
    }

    onCategoryClick = (category) => {

    }
}



export default (CategoryButton);
